import { ICONS } from "@/icons";
import { useApp } from "@/context/AppContext";

export function ProductIcon({
  name,
  className = "h-7 w-7",
}: {
  name: string;
  className?: string;
}) {
  const { theme } = useApp();
  const src =
    theme === "dark" && (name === "macos" || name === "ios")
      ? "/assets/macos-dark.svg"
      : ICONS[name];
  if (!src) return null;
  const browserTileClass = name === "safari" ? "safari-icon" : "";
  return (
    <img
      src={src}
      alt=""
      className={`${className} ${browserTileClass} object-contain pointer-events-none`}
    />
  );
}
